<template>

    <div id="lesson-chat-service">

        <div id="fileUpload" class="position-right" style="display:none">
            <file-upload name="file" input-id="lesson-chatroom-file" class="btn btn-primary"
                extensions="jpeg,jpg,gif,pdf,png,webp,doc,docx"
                accept="image/png, application/pdf, image/gif, image/jpeg, image/webp, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                v-model="files"
                post-action="/uploader/fileUploader" :data="{
                    'current_chatbox_userid': this.current_chatbox_userid,
                    'message_type': this.$props.user_info.user_type,
                    'folder': 'notes',
                }" :headers="{ 'X-CSRF-TOKEN': this.csrf_token }" :multiple="true" :drop="true" :drop-directory="true"
                @input="updatetValue" @input-file="inputFile" @input-filter="inputFilter" ref="upload">
            </file-upload>  
        </div>


        <div class="chatbox-container">


            <div class="card">
                <div class="card-body bg-white pb-4" style="min-height:325px;">

                    <div id="user-chatlog" class="user-chatlog border rounded" @click="onChatMessageClick">
                        <div class="chatlog-wrapper">

                            <div v-for="(chatlog, chatlogIndex) in messages" :key="'my_chatlog_' + chatlogIndex">
                                <div v-if="shouldShowChatDateDivider(messages, chatlogIndex)" class="chat-date-divider">
                                    <span>{{ formatChatDateDividerLabel(chatlog) }}</span>
                                </div>
                                <div
                                    class="chat-row"
                                    :class="isOwnChatMessage(chatlog) ? 'chat-row--mine' : 'chat-row--theirs'"
                                >
                                    <div
                                        v-if="shouldShowSenderLabel(messages, chatlogIndex)"
                                        class="chat-sender-label">
                                        {{ chatlog.sender.nickname }}
                                    </div>
                                    <div class="chat-line">
                                        <div
                                            class="chat-bubble"
                                            @mouseenter="setReactionHover(chatlog, true)"
                                            @mouseleave="setReactionHover(chatlog, false)"
                                        >
                                            <span class="chat-message-body" v-html="formatMessage(chatlog.message)"></span>
                                        <div
                                            v-if="hasMessageReactions(chatlog) || isReactionHovering(chatlog)"
                                            class="chat-reactions"
                                        >
                                            <div class="chat-reaction-summary" v-if="hasMessageReactions(chatlog)">
                                                <button
                                                    v-for="(count, emoji) in chatlog.reactions"
                                                    :key="'rx_' + chatlogIndex + '_' + emoji"
                                                    type="button"
                                                    class="chat-reaction-pill"
                                                    :class="{ 'is-mine': isReactionMine(chatlog, emoji) }"
                                                    @mousedown.prevent
                                                    @click.prevent="toggleReaction(chatlog, emoji)"
                                                >
                                                    <span class="chat-reaction-emoji">{{ emoji }}</span>
                                                    <span class="chat-reaction-count">{{ count }}</span>
                                                </button>
                                            </div>
                                            <div class="chat-reaction-actions" v-show="isReactionHovering(chatlog)">
                                                <button
                                                    v-for="(emoji, rIndex) in reactionQuickList"
                                                    :key="'rxpick_' + chatlogIndex + '_' + rIndex"
                                                    type="button"
                                                    class="chat-reaction-btn"
                                                    :title="'React ' + emoji"
                                                    @mousedown.prevent
                                                    @click.prevent="toggleReaction(chatlog, emoji)"
                                                >
                                                    {{ emoji }}
                                                </button>
                                                <button
                                                    type="button"
                                                    class="chat-reaction-btn chat-reaction-btn--more"
                                                    title="More reactions"
                                                    @mousedown.prevent
                                                    @click.stop.prevent="toggleReactionPicker(chatlog, $event)"
                                                >
                                                    <i class="fas fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="chat-time-outside">{{ displayTimeLabel(chatlog) }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="strike" v-if="unreadMessages.length >= 1">
                                <span class="small">Unread Message(s)</span>
                            </div>

                            <div v-for="(chatlog, chatlogIndex) in unreadMessages" :key="'my_unread_chatlog_' + chatlogIndex">
                                <div v-if="shouldShowChatDateDivider(unreadMessages, chatlogIndex, messages)" class="chat-date-divider">
                                    <span>{{ formatChatDateDividerLabel(chatlog) }}</span>
                                </div>
                                <div
                                    class="chat-row"
                                    :class="isOwnChatMessage(chatlog) ? 'chat-row--mine' : 'chat-row--theirs'"
                                >
                                    <div
                                        v-if="shouldShowSenderLabel(unreadMessages, chatlogIndex)"
                                        class="chat-sender-label">
                                        {{ chatlog.sender.nickname }}
                                    </div>
                                    <div class="chat-line">
                                        <div
                                            class="chat-bubble"
                                            @mouseenter="setReactionHover(chatlog, true)"
                                            @mouseleave="setReactionHover(chatlog, false)"
                                        >
                                            <span class="chat-message-body" v-html="formatMessage(chatlog.message)"></span>
                                        <div
                                            v-if="hasMessageReactions(chatlog) || isReactionHovering(chatlog)"
                                            class="chat-reactions"
                                        >
                                            <div class="chat-reaction-summary" v-if="hasMessageReactions(chatlog)">
                                                <button
                                                    v-for="(count, emoji) in chatlog.reactions"
                                                    :key="'unrx_' + chatlogIndex + '_' + emoji"
                                                    type="button"
                                                    class="chat-reaction-pill"
                                                    :class="{ 'is-mine': isReactionMine(chatlog, emoji) }"
                                                    @mousedown.prevent
                                                    @click.prevent="toggleReaction(chatlog, emoji)"
                                                >
                                                    <span class="chat-reaction-emoji">{{ emoji }}</span>
                                                    <span class="chat-reaction-count">{{ count }}</span>
                                                </button>
                                            </div>
                                            <div class="chat-reaction-actions" v-show="isReactionHovering(chatlog)">
                                                <button
                                                    v-for="(emoji, rIndex) in reactionQuickList"
                                                    :key="'unrxpick_' + chatlogIndex + '_' + rIndex"
                                                    type="button"
                                                    class="chat-reaction-btn"
                                                    :title="'React ' + emoji"
                                                    @mousedown.prevent
                                                    @click.prevent="toggleReaction(chatlog, emoji)"
                                                >
                                                    {{ emoji }}
                                                </button>
                                                <button
                                                    type="button"
                                                    class="chat-reaction-btn chat-reaction-btn--more"
                                                    title="More reactions"
                                                    @mousedown.prevent
                                                    @click.stop.prevent="toggleReactionPicker(chatlog, $event)"
                                                >
                                                    <i class="fas fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="chat-time-outside">{{ displayTimeLabel(chatlog) }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="strike" v-if="newMessageAdded == true">
                                <span class="small">Recent Message(s)</span>
                            </div>

                            <div v-for="(chatlog, chatlogIndex) in recentMessages" :key="'recent_message_log' + chatlogIndex">
                                <div v-if="shouldShowChatDateDivider(recentMessages, chatlogIndex, messages, unreadMessages)" class="chat-date-divider">
                                    <span>{{ formatChatDateDividerLabel(chatlog) }}</span>
                                </div>
                                <div
                                    class="chat-row"
                                    :class="isOwnChatMessage(chatlog) ? 'chat-row--mine' : 'chat-row--theirs'"
                                >
                                    <div
                                        v-if="shouldShowSenderLabel(recentMessages, chatlogIndex)"
                                        class="chat-sender-label">
                                        {{ chatlog.sender.nickname }}
                                    </div>
                                    <div class="chat-line">
                                        <div
                                            class="chat-bubble"
                                            @mouseenter="setReactionHover(chatlog, true)"
                                            @mouseleave="setReactionHover(chatlog, false)"
                                        >
                                            <span class="chat-message-body" v-html="formatMessage(chatlog.message)"></span>
                                        <div
                                            v-if="hasMessageReactions(chatlog) || isReactionHovering(chatlog)"
                                            class="chat-reactions"
                                        >
                                            <div class="chat-reaction-summary" v-if="hasMessageReactions(chatlog)">
                                                <button
                                                    v-for="(count, emoji) in chatlog.reactions"
                                                    :key="'recrx_' + chatlogIndex + '_' + emoji"
                                                    type="button"
                                                    class="chat-reaction-pill"
                                                    :class="{ 'is-mine': isReactionMine(chatlog, emoji) }"
                                                    @mousedown.prevent
                                                    @click.prevent="toggleReaction(chatlog, emoji)"
                                                >
                                                    <span class="chat-reaction-emoji">{{ emoji }}</span>
                                                    <span class="chat-reaction-count">{{ count }}</span>
                                                </button>
                                            </div>
                                            <div class="chat-reaction-actions" v-show="isReactionHovering(chatlog)">
                                                <button
                                                    v-for="(emoji, rIndex) in reactionQuickList"
                                                    :key="'recrxpick_' + chatlogIndex + '_' + rIndex"
                                                    type="button"
                                                    class="chat-reaction-btn"
                                                    :title="'React ' + emoji"
                                                    @mousedown.prevent
                                                    @click.prevent="toggleReaction(chatlog, emoji)"
                                                >
                                                    {{ emoji }}
                                                </button>
                                                <button
                                                    type="button"
                                                    class="chat-reaction-btn chat-reaction-btn--more"
                                                    title="More reactions"
                                                    @mousedown.prevent
                                                    @click.stop.prevent="toggleReactionPicker(chatlog, $event)"
                                                >
                                                    <i class="fas fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="chat-time-outside">{{ displayTimeLabel(chatlog) }}</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div id="user-reply-container" class="lesson-chat-reply mt-2">
                        <div v-if="files.length" class="lesson-chat-attachments-preview">
                            <div v-for="(file, index) in files" :key="file.id"
                                class="lesson-chat-attachment-chip">
                                <button type="button" class="lesson-chat-attachment-remove"
                                    @click.prevent="$refs.upload.remove(file)" aria-label="Remove attachment">&times;</button>
                                <div v-if="file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/webp'">
                                    <img class="lesson-chat-attachment-thumb" :src="file.thumb" :alt="file.name || 'attachment'">
                                </div>
                                <div v-else class="lesson-chat-attachment-file">
                                    <i class="far fa-file" aria-hidden="true"></i>
                                </div>
                                <div class="progress lesson-chat-attachment-progress" v-if="file.active || file.progress !== '0.00'">
                                    <div :class="{ 'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active }"
                                        role="progressbar" :style="{ width: file.progress + '%' }">{{ file.progress }}%</div>
                                </div>
                            </div>
                        </div>

                        <div class="lesson-chat-compose" @paste="handlePaste">
                            <div class="lesson-chat-format-bar" role="toolbar" aria-label="Text formatting">
                                <div class="lesson-chat-format-tools">
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Bold"
                                        :class="{ 'is-active': isEditorCommandActive('bold') }"
                                        :aria-pressed="isEditorCommandActive('bold') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('bold')">
                                        <i class="fas fa-bold" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Italic"
                                        :class="{ 'is-active': isEditorCommandActive('italic') }"
                                        :aria-pressed="isEditorCommandActive('italic') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('italic')">
                                        <i class="fas fa-italic" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Underline"
                                        :class="{ 'is-active': isEditorCommandActive('underline') }"
                                        :aria-pressed="isEditorCommandActive('underline') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('underline')">
                                        <i class="fas fa-underline" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Strikethrough"
                                        :class="{ 'is-active': isEditorCommandActive('strike') }"
                                        :aria-pressed="isEditorCommandActive('strike') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('strike')">
                                        <i class="fas fa-strikethrough" aria-hidden="true"></i>
                                    </button>
                                    <span class="lesson-chat-format-sep" aria-hidden="true"></span>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Bulleted list"
                                        :class="{ 'is-active': isEditorCommandActive('bulletedlist') }"
                                        :aria-pressed="isEditorCommandActive('bulletedlist') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('bulletedlist')">
                                        <i class="fas fa-list-ul" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Numbered list"
                                        :class="{ 'is-active': isEditorCommandActive('numberedlist') }"
                                        :aria-pressed="isEditorCommandActive('numberedlist') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('numberedlist')">
                                        <i class="fas fa-list-ol" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Quote"
                                        :class="{ 'is-active': isEditorCommandActive('blockquote') }"
                                        :aria-pressed="isEditorCommandActive('blockquote') ? 'true' : 'false'"
                                        @mousedown.prevent @click.prevent="execEditorCommand('blockquote')">
                                        <i class="fas fa-quote-right" aria-hidden="true"></i>
                                    </button>
                                    <span class="lesson-chat-format-sep" aria-hidden="true"></span>
                                    <div class="lesson-chat-format-more" ref="paragraphStyleMenu">
                                        <button type="button"
                                            class="btn btn-sm btn-link lesson-chat-tool-btn lesson-chat-paragraph-style-btn"
                                            title="Paragraph style"
                                            :class="{ 'is-active': showParagraphStyleMenu }"
                                            :aria-expanded="showParagraphStyleMenu ? 'true' : 'false'"
                                            aria-haspopup="true"
                                            @mousedown.prevent @click.prevent="toggleParagraphStyleMenu">
                                            <span class="lesson-chat-paragraph-style-label">Paragraph style</span>
                                            <i class="fas fa-caret-down lesson-chat-paragraph-style-caret" aria-hidden="true"></i>
                                        </button>
                                        <div v-show="showParagraphStyleMenu" class="lesson-chat-format-menu" role="menu">
                                            <button type="button" class="lesson-chat-format-menu-item" role="menuitem"
                                                @mousedown.prevent @click.prevent="applyParagraphFormat('p')">
                                                Paragraph
                                            </button>
                                            <button type="button" class="lesson-chat-format-menu-item" role="menuitem"
                                                @mousedown.prevent @click.prevent="applyParagraphFormat('h3')">
                                                Heading
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="lesson-chat-editor-wrap">
                                <vue-ckeditor id="message" ref="ckeditorMessage" v-model="privateMessage"
                                    :config="editorConfig" />
                            </div>

                            <div class="lesson-chat-actions-bar">
                                <div class="lesson-chat-actions-left">
                                    <div class="lesson-chat-emoji" ref="emojiMenu">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-link lesson-chat-tool-btn"
                                            title="Insert emoji"
                                            :class="{ 'is-active': showEmojiPicker }"
                                            :aria-expanded="showEmojiPicker ? 'true' : 'false'"
                                            aria-haspopup="true"
                                            @mousedown.prevent
                                            @click.prevent="toggleEmojiPicker"
                                        >
                                            <i class="far fa-smile" aria-hidden="true"></i>
                                        </button>
                                        <div v-show="showEmojiPicker" class="lesson-chat-emoji-menu lesson-chat-emoji-menu--teams" role="menu">
                                            <div class="lesson-chat-emoji-header">
                                                <input
                                                    v-model="emojiPickerSearch"
                                                    class="lesson-chat-emoji-search"
                                                    type="text"
                                                    placeholder="Search"
                                                    autocomplete="off"
                                                    @mousedown.stop
                                                    @click.stop
                                                    @keydown.stop
                                                >
                                                <div class="lesson-chat-emoji-tabs" role="tablist" aria-label="Emoji categories">
                                                    <button
                                                        v-for="(tab, tIndex) in emojiPickerTabs"
                                                        :key="'emtab_' + tIndex"
                                                        type="button"
                                                        class="lesson-chat-emoji-tab"
                                                        :class="{ 'is-active': emojiPickerTab === tab.id }"
                                                        role="tab"
                                                        :aria-selected="emojiPickerTab === tab.id ? 'true' : 'false'"
                                                        @mousedown.prevent
                                                        @click.prevent="emojiPickerTab = tab.id"
                                                        :title="tab.label"
                                                    >
                                                        <span aria-hidden="true">{{ tab.icon }}</span>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="lesson-chat-emoji-body" role="presentation">
                                                <div class="lesson-chat-emoji-section" v-if="emojiPickerTabLabel">
                                                    <div class="lesson-chat-emoji-section-title">{{ emojiPickerTabLabel }}</div>
                                                </div>
                                                <div class="lesson-chat-emoji-grid" role="menu">
                                                    <button
                                                        v-for="(emoji, emojiIndex) in emojiPickerVisibleEmojis"
                                                        :key="'emoji2_' + emojiPickerTab + '_' + emojiIndex + '_' + emoji"
                                                        type="button"
                                                        class="lesson-chat-emoji-item"
                                                        role="menuitem"
                                                        @mousedown.prevent
                                                        @click.prevent="insertEmoji(emoji)"
                                                    >
                                                        {{ emoji }}
                                                    </button>
                                                    <div v-if="!emojiPickerVisibleEmojis.length" class="lesson-chat-emoji-empty">
                                                        No results
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <label id="file-select-button" for="lesson-chatroom-file"
                                        class="btn btn-sm btn-link lesson-chat-tool-btn" title="Attach file">
                                        <i class="fas fa-paperclip" aria-hidden="true"></i>
                                    </label>
                                    <button type="button" class="btn btn-sm btn-link lesson-chat-tool-btn" title="Attach image"
                                        @click.prevent="openFilePicker()">
                                        <i class="far fa-image" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="lesson-chat-actions-right">
                                    <button type="button" class="lesson-chat-send-btn"
                                        title="Send message"
                                        @click.prevent="sendComposeMessage()">
                                        <i class="fas fa-paper-plane" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <ImageViewerComponent ref="ImageViewerComponent" />

        <div
            v-show="reactionPickerKey"
            class="chat-reaction-picker-portal"
            :style="reactionPickerStyle"
            role="menu"
        >
            <div class="chat-reaction-picker-header">
                <input
                    v-model="reactionPickerSearch"
                    class="chat-reaction-picker-search"
                    type="text"
                    placeholder="Search"
                    autocomplete="off"
                    @mousedown.stop
                    @click.stop
                    @keydown.stop
                >
                <div class="chat-reaction-picker-tabs" role="tablist" aria-label="Reaction categories">
                    <button
                        v-for="(tab, tIndex) in reactionPickerTabs"
                        :key="'rxtab_' + tIndex"
                        type="button"
                        class="chat-reaction-picker-tab"
                        :class="{ 'is-active': reactionPickerTab === tab.id }"
                        role="tab"
                        :aria-selected="reactionPickerTab === tab.id ? 'true' : 'false'"
                        @mousedown.prevent
                        @click.prevent="reactionPickerTab = tab.id"
                        :title="tab.label"
                    >
                        <span aria-hidden="true">{{ tab.icon }}</span>
                    </button>
                </div>
            </div>

            <div class="chat-reaction-picker-body" role="presentation">
                <div class="chat-reaction-picker-section" v-if="reactionPickerTabLabel">
                    <div class="chat-reaction-picker-section-title">{{ reactionPickerTabLabel }}</div>
                </div>
                <div class="chat-reaction-picker-grid" role="menu">
                    <button
                        v-for="(emoji, eIndex) in reactionPickerVisibleEmojis"
                        :key="'rxportal_' + reactionPickerTab + '_' + eIndex + '_' + emoji"
                        type="button"
                        class="chat-reaction-picker-item"
                        :title="'React ' + emoji"
                        @mousedown.prevent
                        @click.prevent="toggleReactionFromPortal(emoji)"
                    >
                        {{ emoji }}
                    </button>
                    <div v-if="!reactionPickerVisibleEmojis.length" class="chat-reaction-picker-empty">
                        No results
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import ImageViewerComponent from "../../image/imageViewerComponent.vue"
import VueCkeditor from 'vue-ckeditor2'

var socket = null;

export default {
    name: "lessonSliderChatroomComponent",
    components: {
        FileUpload, ImageViewerComponent, VueCkeditor
    },
    data() {

        return {


            privateMessage: "",

            chatEditorMinHeight: 44,
            chatEditorMaxHeight: 200,

            showParagraphStyleMenu: false,
            showEmojiPicker: false,
            emojiQuickList: ['😀', '😁', '😂', '😊', '😉', '😍', '😘', '😅', '😢', '😡', '👍', '👎', '👏', '🙏', '❤️', '🎉', '✅', '❌'],
            emojiPickerSearch: '',
            emojiPickerTab: 'recent',
            emojiPickerRecent: [],
            emojiPickerRecentLimit: 30,
            emojiPickerStorageKey: 'lessonChatComposeEmojiRecentV1',
            reactionQuickList: ['👍', '❤️', '😂', '😮', '😢', '😡', '👏'],
            reactionEmojiList: [
                '👍', '👎', '❤️', '😂', '😮', '😢', '😡', '👏', '🎉', '🔥', '🙏', '✅', '❌',
                '😀', '😁', '😅', '😊', '😉', '😍', '😘', '🤔', '😴', '😎', '🤩',
                '🙌', '💯', '✨', '🌟', '💪', '🤝', '🙈', '🎯', '📌', '📝',
            ],
            reactionHoverKey: '',
            reactionPickerKey: '',
            reactionPickerStyle: {
                top: '0px',
                left: '0px',
            },
            reactionPickerChatlog: null,
            reactionPickerSearch: '',
            reactionPickerTab: 'recent',
            reactionPickerRecent: [],
            reactionPickerRecentLimit: 24,
            reactionPickerStorageKey: 'lessonChatReactionRecentV1',

            editorFormatState: {
                bold: false,
                italic: false,
                underline: false,
                strike: false,
                bulletedlist: false,
                numberedlist: false,
                blockquote: false,
            },

            editorConfig: {
                resize_enabled: false,
                toolbar: [],
                allowedContent: true,
                extraPlugins: 'basicstyles,blockquote,list,format,liststyle',
                format_tags: 'p;h3;pre',
                removePlugins: 'elementspath,easyimage,cloudservices,exportpdf,resize,colorbutton,colordialog,font,fontSize',
                height: 44,
                uiColor: '#ffffff',
                contentsCss: [
                    'body { margin: 4px 8px !important; padding: 0 !important; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif !important; font-size: 14px !important; line-height: 1.45; background: transparent; color: #212529; }',
                    'p { margin: 0 0 6px; }',
                    'h3 { margin: 0 0 6px; font-size: 1.05rem; font-weight: 600; }',
                    'pre { margin: 0 0 6px; padding: 6px 8px; background: #f1f3f4; border-radius: 4px; font-size: 13px; }',
                    'ul, ol { margin: 0 0 6px; padding-left: 1.25rem; }',
                    'strong, b { font-weight: 700; }',
                    'em, i { font-style: italic; }',
                    'u { text-decoration: underline; }',
                ],
                /*
                on: 
                {
                    paste: (evt) => {
               
                  
                                                    
                    }   
                } 
                */
            },



            //history is fetching status
            isFetching: false,
            interval: "",

            //first load on opening chatbox
            firstLoad: true,



            messages: [],

            unreadMessages: [],
            recentMessages: [],


            users: [],

            //chat boxes
            message_count: 0,
            unread_message_count: 0,


            //this will hold the current recipient userid
            current_chatbox_userid: "",

            //uploader
            files: [],

            //History Loaders
            loadingHistory: false,
            historyNotifier: true,

            //buttons
            ButtonSend: null,
            ButtonUpload: null,

            //page
            page: [],


            newMessageAdded: false,

            usingSharedSocket: false,
            privateMessageHandler: null,
            chatPollInterval: null,
            lastHistoryPollAt: 0,
            historyRequestSeq: 0,
        };
    },
    props: {
        userid: String,
        username: String,
        nickname: String,
        user_image: String,
        api_token: String,
        csrf_token: String,
        chatserver_url: String,
        show_sidebar: Boolean,

        channelid: {
            type: [String, Number],
            required: true
        },
        canvas_server: {
            type: [String],
            required: true
        },
        user_info: {
            type: [Object, String],
            required: true
        },
        member_info: {
            type: [Object, String],
            required: true
        },
        recipient_info: {
            type: [Object, String],
            required: true
        },
        isBroadcaster: {
            type: [Boolean],
            required: true
        },

    },

    mounted() {

        //Transfer the object to the window
        window.lessonSliderChatroom = this;

        this.privateMessageHandler = (response) => {
            this.onPrivateMessageReceived(response);
        };

        this.connectChatSocket();

        this._onLessonSocketReady = (event) => {
            if (event.detail && event.detail.socket) {
                this.bindChatToLessonSocket(event.detail.socket);
            }
        };
        window.addEventListener('lesson-socket-ready', this._onLessonSocketReady);

        this.$nextTick(() => {
            if (window.lessonSliderComponent && window.lessonSliderComponent.socket) {
                this.bindChatToLessonSocket(window.lessonSliderComponent.socket);
            }
        });

        const user = this.getUser();
        this.initializeChatBox(user);
        this.getChatHistory();

        window.addEventListener("keyup", (e) => {
            this.prepareButtons();
        });


        this.startChatPolling();

        //add the image viewer
        document.body.addEventListener("click", this.imageViewerClick);
        document.addEventListener("click", this.onDocumentClickForParagraphMenu);
        document.addEventListener("click", this.onDocumentClickForReactionPicker);
        window.addEventListener("resize", this.repositionReactionPicker);
        document.addEventListener("click", this.onDocumentClickForEmojiMenu);

        this.loadReactionPickerRecent();
        this.loadEmojiPickerRecent();

        // Teleport the reaction picker portal to <body> so that the chat panel's
        // CSS transform (translateX) does not break position:fixed on the picker.
        this.$nextTick(() => {
            const portal = this.$el && this.$el.querySelector('.chat-reaction-picker-portal');
            if (portal) {
                document.body.appendChild(portal);
                this._rxPortalEl = portal;
            }
        });

        if (window.CKEDITOR) {
            CKEDITOR.on('instanceReady', (evt) => {
                const editor = evt.editor; // CKEditor instance
                if (editor.name === 'message') { // match by id if needed
                    this.onEditorReady(editor);
                }
            });
        }




    },
    watch: {
        channelid(newVal, oldVal) {
            if (newVal == null || newVal === '' || String(newVal) === String(oldVal)) {
                return;
            }
            this.clearChatMessages();
            this.getChatHistory();
        },
    },
    beforeDestroy() {
        if (this._onLessonSocketReady) {
            window.removeEventListener('lesson-socket-ready', this._onLessonSocketReady);
        }
        window.removeEventListener('paste', this.handlePaste);
        document.removeEventListener('click', this.onDocumentClickForParagraphMenu);
        document.removeEventListener("click", this.onDocumentClickForReactionPicker);
        window.removeEventListener("resize", this.repositionReactionPicker);
        document.removeEventListener('click', this.onDocumentClickForEmojiMenu);

        if (this._rxPortalEl && this._rxPortalEl.parentNode) {
            this._rxPortalEl.parentNode.removeChild(this._rxPortalEl);
            this._rxPortalEl = null;
        }

        if (this.socket && this.privateMessageHandler) {
            this.socket.off('SEND_SLIDE_PRIVATE_MESSAGE', this.privateMessageHandler);
        }

        if (this.socket && !this.usingSharedSocket) {
            this.socket.disconnect();
        }

        if (this.chatPollInterval) {
            clearInterval(this.chatPollInterval);
        }
    },
    methods: {
        activeChannelId() {
            if (typeof window !== 'undefined' && window.LESSON_ROOM_ID) {
                return String(window.LESSON_ROOM_ID);
            }
            return String(this.channelid);
        },
        clearChatMessages() {
            this.messages = [];
            this.unreadMessages = [];
            this.recentMessages = [];
        },
        isMessageForActiveChannel(data) {
            if (!data) {
                return false;
            }
            const myChannel = this.activeChannelId();
            const msgChannel = data.channelid != null ? String(data.channelid) : '';
            if (msgChannel !== '') {
                return msgChannel === myChannel;
            }
            const peerId = String(
                (this.getRecipient() && (this.getRecipient().userid || this.getRecipient().userId)) || ''
            );
            const myId = String(this.current_chatbox_userid || '');
            const senderId = String(
                (data.sender && (data.sender.userid || data.sender.userId)) || data.sender_id || ''
            );
            const recipientId = String(
                (data.recipient && (data.recipient.userid || data.recipient.userId)) || data.recipient_id || ''
            );
            if (!peerId || !myId) {
                return false;
            }
            const involvesMe = senderId === myId || recipientId === myId;
            const involvesPeer = senderId === peerId || recipientId === peerId;
            return involvesMe && involvesPeer;
        },
        bindChatToLessonSocket(socket) {
            if (!socket || !this.privateMessageHandler) {
                return;
            }

            if (this.socket && this.socket !== socket) {
                this.socket.off('SEND_SLIDE_PRIVATE_MESSAGE', this.privateMessageHandler);
                if (this.reactionMessageHandler) {
                    this.socket.off('SEND_SLIDE_PRIVATE_REACTION', this.reactionMessageHandler);
                }
                if (this._chatConnectHandler) {
                    this.socket.off('connect', this._chatConnectHandler);
                }
            }

            this.socket = socket;
            this.usingSharedSocket = !!(window.lessonSliderComponent && window.lessonSliderComponent.socket === socket);

            this.socket.off('SEND_SLIDE_PRIVATE_MESSAGE', this.privateMessageHandler);
            this.socket.on('SEND_SLIDE_PRIVATE_MESSAGE', this.privateMessageHandler);

            if (!this.reactionMessageHandler) {
                this.reactionMessageHandler = (payload) => {
                    this.onReactionReceived(payload);
                };
            }
            this.socket.off('SEND_SLIDE_PRIVATE_REACTION', this.reactionMessageHandler);
            this.socket.on('SEND_SLIDE_PRIVATE_REACTION', this.reactionMessageHandler);

            if (!this._chatConnectHandler) {
                this._chatConnectHandler = () => {
                    const user = this.getUser();
                    if (user && this.socket) {
                        this.socket.emit('REGISTER', user);
                    }
                };
            }
            this.socket.off('connect', this._chatConnectHandler);
            this.socket.on('connect', this._chatConnectHandler);

            if (this.socket.connected) {
                const user = this.getUser();
                if (user) {
                    this.socket.emit('REGISTER', user);
                }
            }
        },

        getChatEditor() {
            if (this.$refs.ckeditorMessage && this.$refs.ckeditorMessage.instance) {
                return this.$refs.ckeditorMessage.instance;
            }
            if (typeof window !== 'undefined' && window.CKEDITOR && window.CKEDITOR.instances.message) {
                return window.CKEDITOR.instances.message;
            }
            return null;
        },
        isEditorCommandActive(command) {
            return !!(this.editorFormatState && this.editorFormatState[command]);
        },
        syncEditorFormatState() {
            const editor = this.getChatEditor();
            const commands = ['bold', 'italic', 'underline', 'strike', 'bulletedlist', 'numberedlist', 'blockquote'];
            const nextState = {};

            if (!editor || typeof window === 'undefined' || !window.CKEDITOR) {
                commands.forEach((command) => {
                    nextState[command] = false;
                });
                this.editorFormatState = nextState;
                return;
            }

            const tristateOn = window.CKEDITOR.TRISTATE_ON;

            commands.forEach((command) => {
                const ckCommand = editor.getCommand(command);
                nextState[command] = !!(ckCommand && ckCommand.state === tristateOn);
            });

            this.editorFormatState = nextState;
        },
        execEditorCommand(command, value) {
            const editor = this.getChatEditor();
            if (!editor) {
                return;
            }
            editor.focus();
            if (command === 'format' && value) {
                editor.execCommand('format', false, value);
                this.$nextTick(() => this.syncEditorFormatState());
                return;
            }
            editor.execCommand(command);
            this.$nextTick(() => this.syncEditorFormatState());
        },
        toggleParagraphStyleMenu() {
            this.showParagraphStyleMenu = !this.showParagraphStyleMenu;
        },
        closeParagraphStyleMenu() {
            this.showParagraphStyleMenu = false;
        },
        applyParagraphFormat(tag) {
            this.execEditorCommand('format', tag);
            this.closeParagraphStyleMenu();
        },
        onDocumentClickForParagraphMenu(event) {
            if (!this.showParagraphStyleMenu) {
                return;
            }
            const menuRoot = this.$refs.paragraphStyleMenu;
            if (menuRoot && menuRoot.contains(event.target)) {
                return;
            }
            this.closeParagraphStyleMenu();
        },
        toggleEmojiPicker() {
            this.showEmojiPicker = !this.showEmojiPicker;
            if (this.showEmojiPicker) {
                this.emojiPickerSearch = '';
                if (!this.emojiPickerTab) {
                    this.emojiPickerTab = 'recent';
                }
            }
        },
        closeEmojiPicker() {
            this.showEmojiPicker = false;
        },
        onDocumentClickForEmojiMenu(event) {
            if (!this.showEmojiPicker) {
                return;
            }
            const menuRoot = this.$refs.emojiMenu;
            if (menuRoot && menuRoot.contains(event.target)) {
                return;
            }
            this.closeEmojiPicker();
        },
        insertEmoji(emoji) {
            const editor = this.getChatEditor();
            if (!editor || !emoji) {
                return;
            }
            this.addEmojiPickerRecent(emoji);
            editor.focus();
            // Insert as plain text to avoid HTML sanitization issues.
            editor.insertText(String(emoji));
            this.privateMessage = editor.getData();
            this.closeEmojiPicker();
            this.$nextTick(() => {
                this.resizeChatEditor();
                this.syncEditorFormatState();
            });
        },
        loadEmojiPickerRecent() {
            try {
                const raw = window && window.localStorage ? window.localStorage.getItem(this.emojiPickerStorageKey) : null;
                const parsed = raw ? JSON.parse(raw) : [];
                this.emojiPickerRecent = Array.isArray(parsed) ? parsed.filter(Boolean) : [];
            } catch (e) {
                this.emojiPickerRecent = [];
            }
        },
        saveEmojiPickerRecent() {
            try {
                if (window && window.localStorage) {
                    window.localStorage.setItem(this.emojiPickerStorageKey, JSON.stringify(this.emojiPickerRecent || []));
                }
            } catch (e) {
                // ignore
            }
        },
        addEmojiPickerRecent(emoji) {
            const e = String(emoji || '').trim();
            if (!e) {
                return;
            }
            const next = [e].concat((this.emojiPickerRecent || []).filter((x) => x !== e));
            this.emojiPickerRecent = next.slice(0, Number(this.emojiPickerRecentLimit || 30));
            this.saveEmojiPickerRecent();
        },
        openFilePicker() {
            const input = document.getElementById('lesson-chatroom-file');
            if (input) {
                input.click();
            }
        },
        resizeChatEditor() {
            const editor = this.getChatEditor();
            if (!editor) {
                return;
            }

            const editable = editor.editable();
            if (!editable) {
                return;
            }

            const element = editable.$;
            element.style.height = 'auto';
            const contentHeight = Math.max(element.scrollHeight, this.chatEditorMinHeight);
            const nextHeight = Math.min(contentHeight + 8, this.chatEditorMaxHeight);
            editor.resize('100%', nextHeight, true);
        },
        clearComposeMessage() {
            this.privateMessage = '';
            const editor = this.getChatEditor();
            if (editor) {
                editor.setData('');
            }
            this.$nextTick(() => {
                this.resizeChatEditor();
                this.prepareButtons();
                this.syncEditorFormatState();
            });
        },
        sendComposeMessage() {
            if (this.$refs.upload) {
                this.$refs.upload.active = false;
            }
            this.sendMessage(this.privateMessage);
        },
        handleKeyDown(event) {
            if (event.ctrlKey) {
                console.log("🔹 Ctrl pressed ");
            }
        },
        imageViewerClick(event) {
            // Check if the clicked element has the "img_preview" class
            if (event.target.classList.contains("img_preview")) {
                event.preventDefault();
                // Extract the image URL from the clicked element and open the modal
                const imageUrl = event.target.getAttribute("src");

                //this.$refs.ImageViewerComponent.isModalOpen = true; // Open the modal
                //this.$refs.ImageViewerComponent.modalImageUrl = imageUrl; // Set the image URL

                this.$refs.ImageViewerComponent.openModal(imageUrl); // Open the modal

            }
        },
        onChatMessageClick(event) {
            const link = event.target.closest('a[href]');
            if (!link || !event.currentTarget.contains(link) || link.classList.contains('img_preview')) {
                return;
            }
            const href = link.getAttribute('href');
            if (!this.isClickableUrl(href)) {
                event.preventDefault();
                return;
            }
            if (!link.classList.contains('chat-link')) {
                link.classList.add('chat-link');
            }
            if (!link.getAttribute('target')) {
                event.preventDefault();
                window.open(this.toLinkHref(href.trim()), '_blank', 'noopener,noreferrer');
            }
        },
        isClickableUrl(url) {
            if (!url || typeof url !== 'string') {
                return false;
            }
            const trimmed = url.trim();
            if (!trimmed || trimmed === '#') {
                return false;
            }
            return /^(https?:\/\/|ftp:\/\/)/i.test(trimmed)
                || /^www\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z]{2,})+/i.test(trimmed);
        },
        toLinkHref(url) {
            if (/^www\./i.test(url)) {
                return 'https://' + url;
            }
            return url;
        },
        escapeHtml(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },
        stripHtmlToText(html) {
            if (!html) {
                return '';
            }
            const el = document.createElement('div');
            el.innerHTML = String(html);
            return (el.textContent || '')
                .replace(/\u00a0/g, ' ')
                .replace(/[\u200B-\u200D\uFE0E\uFE0F]/g, '') // ZWSP/ZWJ + variation selectors
                .trim();
        },
        isEmojiOnlyMessage(text) {
            const trimmed = String(text || '').trim();
            if (!trimmed) {
                return false;
            }

            // Must contain at least one pictographic emoji.
            try {
                const hasEmoji = /\p{Extended_Pictographic}/u.test(trimmed);
                if (!hasEmoji) {
                    return false;
                }
                // Allow: emoji, modifiers/components, VS16, ZWJ, keycap, whitespace.
                return /^(?:\p{Extended_Pictographic}|\p{Emoji_Component}|\uFE0F|\u200D|\u20E3|[#*0-9]|\s)+$/u.test(trimmed);
            } catch (e) {
                // Fallback for environments without Unicode property escapes.
                return trimmed.length <= 12 && !/[a-z0-9]/i.test(trimmed);
            }
        },
        emojiCount(text) {
            const trimmed = String(text || '').trim();
            if (!trimmed) {
                return 0;
            }
            try {
                const matches = trimmed.match(/\p{Extended_Pictographic}/gu);
                return matches ? matches.length : 0;
            } catch (e) {
                return 0;
            }
        },
        formatMessage(message) {
            if (message === null || message === undefined || message === '') {
                return '';
            }
            const raw = String(message);
            const plain = this.stripHtmlToText(raw);
            if (this.isEmojiOnlyMessage(plain)) {
                // Keep message safe (existing messages may contain HTML).
                const count = this.emojiCount(plain);
                const sizeClass = count <= 1 ? 'emoji-only--xl' : (count <= 3 ? 'emoji-only--lg' : 'emoji-only--md');
                return '<span class="emoji-only ' + sizeClass + '">' + this.escapeHtml(plain) + '</span>';
            }
            return this.linkify(raw);
        },
        messageKey(chatlog) {
            if (!chatlog) {
                return '';
            }
            return String(chatlog.dbId || chatlog.clientMsgId || chatlog.sentAt || chatlog.timeLabel || Math.random());
        },
        setReactionHover(chatlog, on) {
            if (!chatlog) {
                return;
            }
            this.reactionHoverKey = on ? this.messageKey(chatlog) : '';
        },
        isReactionHovering(chatlog) {
            return !!chatlog && this.reactionHoverKey === this.messageKey(chatlog);
        },
        toggleReactionPicker(chatlog, event) {
            if (!chatlog) {
                return;
            }
            const key = this.messageKey(chatlog);
            if (this.reactionPickerKey === key) {
                this.reactionPickerKey = '';
                this.reactionPickerChatlog = null;
                this.reactionPickerSearch = '';
                return;
            }
            this.reactionPickerKey = key;
            this.reactionPickerChatlog = chatlog;
            this.reactionPickerSearch = '';
            this.$nextTick(() => {
                this.positionReactionPickerFromEvent(event);
            });
        },
        getReactionPickerDims() {
            const el = this._rxPortalEl || (this.$el && this.$el.querySelector && this.$el.querySelector('.chat-reaction-picker-portal'));
            if (!el || typeof el.getBoundingClientRect !== 'function') {
                return { width: 360, height: 360 };
            }
            const rect = el.getBoundingClientRect();
            const width = Math.max(280, Math.round(rect.width || 360));
            const height = Math.max(260, Math.round(rect.height || 360));
            return { width, height };
        },
        positionReactionPickerFromEvent(event) {
            const anchor = event && (event.currentTarget || event.target);
            if (!anchor || typeof anchor.getBoundingClientRect !== 'function') {
                return;
            }
            const rect = anchor.getBoundingClientRect();
            const dims = this.getReactionPickerDims();
            const pickerWidth = dims.width;
            const pickerHeight = dims.height;
            const padding = 8;

            // Clamp left edge to the chat panel so the picker never spills outside it.
            const chatPanel = document.querySelector('#lesson-chat-service')
                           || document.querySelector('.lesson-stage-chat');
            const panelRect = chatPanel ? chatPanel.getBoundingClientRect() : null;
            const panelLeft = panelRect ? panelRect.left : 0;
            const panelRight = panelRect ? panelRect.right : window.innerWidth;

            const rowEl = (anchor.closest && anchor.closest('.chat-row')) ? anchor.closest('.chat-row') : null;
            const isTheirs = !!(rowEl && rowEl.classList && rowEl.classList.contains('chat-row--theirs'));

            // For left-side bubbles, anchor to the left edge of the "+" button.
            // For right-side bubbles, anchor to the right edge (current behavior).
            let left = isTheirs ? rect.left : (rect.right - pickerWidth);
            const minLeft = panelLeft + padding;
            const maxLeft = panelRight - pickerWidth - padding;
            left = Math.max(minLeft, Math.min(left, maxLeft, window.innerWidth - pickerWidth - padding));

            let top = rect.top - pickerHeight - 8;
            if (top < padding) {
                top = rect.bottom + 8;
            }
            top = Math.max(padding, Math.min(top, window.innerHeight - pickerHeight - padding));

            this.reactionPickerStyle = {
                left: `${Math.round(left)}px`,
                top: `${Math.round(top)}px`,
            };
        },
        repositionReactionPicker() {
            // Best-effort keep picker on-screen on resize.
            if (!this.reactionPickerKey) {
                return;
            }
            const dims = this.getReactionPickerDims();
            const style = this.reactionPickerStyle || {};
            const left = Math.max(8, Math.min(parseInt(style.left || '0', 10) || 0, window.innerWidth - dims.width));
            const top = Math.max(8, Math.min(parseInt(style.top || '0', 10) || 0, window.innerHeight - dims.height));
            this.reactionPickerStyle = { left: `${left}px`, top: `${top}px` };
        },
        onDocumentClickForReactionPicker(event) {
            if (!this.reactionPickerKey) {
                return;
            }
            // Portal is teleported to <body>, so check _rxPortalEl directly.
            const portal = this._rxPortalEl || (this.$el && this.$el.querySelector && this.$el.querySelector('.chat-reaction-picker-portal'));
            if (portal && portal.contains(event.target)) {
                return;
            }
            // Allow clicking the "+" button without immediate close (it stops propagation anyway).
            this.reactionPickerKey = '';
            this.reactionPickerChatlog = null;
        },
        toggleReactionFromPortal(emoji) {
            if (!this.reactionPickerChatlog) {
                return;
            }
            this.toggleReaction(this.reactionPickerChatlog, emoji);
            this.addReactionPickerRecent(emoji);
            // keep picker open (Teams behavior); comment next line to auto-close
            // this.reactionPickerKey = '';
        },
        loadReactionPickerRecent() {
            try {
                const raw = window && window.localStorage ? window.localStorage.getItem(this.reactionPickerStorageKey) : null;
                const parsed = raw ? JSON.parse(raw) : [];
                this.reactionPickerRecent = Array.isArray(parsed) ? parsed.filter(Boolean) : [];
            } catch (e) {
                this.reactionPickerRecent = [];
            }
        },
        saveReactionPickerRecent() {
            try {
                if (window && window.localStorage) {
                    window.localStorage.setItem(this.reactionPickerStorageKey, JSON.stringify(this.reactionPickerRecent || []));
                }
            } catch (e) {
                // ignore
            }
        },
        addReactionPickerRecent(emoji) {
            const e = String(emoji || '').trim();
            if (!e) return;
            const next = [e].concat((this.reactionPickerRecent || []).filter((x) => x !== e));
            this.reactionPickerRecent = next.slice(0, Number(this.reactionPickerRecentLimit || 24));
            this.saveReactionPickerRecent();
        },
        ensureReactionState(chatlog) {
            if (!chatlog) {
                return;
            }
            if (!chatlog.reactions) {
                this.$set(chatlog, 'reactions', {});
            }
            if (!chatlog.myReactions) {
                this.$set(chatlog, 'myReactions', {});
            }
        },
        hasMessageReactions(chatlog) {
            return !!(chatlog && chatlog.reactions && Object.keys(chatlog.reactions).some((k) => chatlog.reactions[k] > 0));
        },
        isReactionMine(chatlog, emoji) {
            return !!(chatlog && chatlog.myReactions && chatlog.myReactions[emoji]);
        },
        toggleReaction(chatlog, emoji) {
            if (!chatlog || !emoji) {
                return;
            }
            // Persist + broadcast so both sides see it in real time.
            const messageId = chatlog.dbId;
            if (!messageId) {
                return;
            }

            axios.post("/api/toggleLessonChatReaction?api_token=" + this.api_token, {
                message_id: messageId,
                emoji: emoji,
                channelid: String(this.channelid),
            }).then((res) => {
                const data = res && res.data ? res.data : null;
                if (!data || data.success !== true) {
                    return;
                }

                this.ensureReactionState(chatlog);
                this.$set(chatlog, 'reactions', data.reactions || {});
                this.$set(chatlog, 'myReactions', data.myReactions || {});

                const payload = {
                    channelid: String(this.channelid),
                    message_id: data.message_id,
                    emoji: data.emoji,
                    action: data.action,
                    reactions: data.reactions || {},
                    myReactions: data.myReactions || {},
                    user_id: data.user_id,
                    recipient: chatlog.recipient || {},
                    sender: chatlog.sender || {},
                };

                if (this.socket) {
                    this.socket.emit('SEND_SLIDE_PRIVATE_REACTION', payload);
                }
            });
        },
        linkify(text) {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = text;

            tempElement.querySelectorAll('a[href]').forEach((anchor) => {
                const href = anchor.getAttribute('href');
                if (!this.isClickableUrl(href)) {
                    return;
                }
                anchor.classList.add('chat-link');
                anchor.setAttribute('href', this.toLinkHref(href.trim()));
                anchor.setAttribute('target', '_blank');
                anchor.setAttribute('rel', 'noopener noreferrer');
            });

            const textNodes = [];
            const treeWalker = document.createTreeWalker(tempElement, NodeFilter.SHOW_TEXT, null, false);
            while (treeWalker.nextNode()) {
                textNodes.push(treeWalker.currentNode);
            }

            const urlRegex = /\b(https?:\/\/[^\s<]+[^\s<.,;:!?\)\]\}'"]|www\.[a-z0-9][\w.-]*[a-z0-9](?:\.[a-z]{2,})+[^\s<.,;:!?\)\]\}'"]*)/gi;

            textNodes.forEach((node) => {
                const parent = node.parentNode;
                if (!parent || parent.tagName === 'A' || parent.tagName === 'IMG') {
                    return;
                }

                const nodeText = node.nodeValue;
                const replacedText = nodeText.replace(urlRegex, (url) => {
                    if (!this.isClickableUrl(url)) {
                        return url;
                    }
                    const href = this.escapeHtml(this.toLinkHref(url));
                    const label = this.escapeHtml(url);
                    return '<a class="chat-link" href="' + href + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
                });

                if (replacedText !== nodeText) {
                    const newNode = document.createElement('span');
                    newNode.innerHTML = replacedText;
                    parent.replaceChild(newNode, node);
                }
            });

            return tempElement.innerHTML;
        },

        popUpImage(index, message) {
            return false;
        },
        connectChatSocket() {
            const lessonSlider = window.lessonSliderComponent;
            const sharedSocket = lessonSlider && lessonSlider.socket;

            if (sharedSocket) {
                this.bindChatToLessonSocket(sharedSocket);
                return;
            }

            if (typeof window.io === 'undefined') {
                console.warn('[lesson-chat] socket.io not loaded');
                return;
            }

            this.socket = window.io(this.$props.canvas_server, {
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionAttempts: 10,
                reconnectionDelay: 1000,
            });
            this.usingSharedSocket = false;
            this.bindChatToLessonSocket(this.socket);
        },
        startChatPolling() {
            if (this.chatPollInterval) {
                clearInterval(this.chatPollInterval);
            }

            this.lastHistoryPollAt = Date.now();
            this.chatPollInterval = setInterval(() => {
                const socketDown = !this.socket || !this.socket.connected;
                if (socketDown) {
                    this.pollChatHistory();
                }
            }, 5000);
        },
        pollChatHistory() {
            this.lastHistoryPollAt = Date.now();
            const channelid = this.activeChannelId();
            const requestSeq = ++this.historyRequestSeq;

            axios.post("/api/getLessonChathistory?api_token=" + this.api_token, {
                method: "POST",
                channelid: channelid,
            }).then((response) => {
                if (requestSeq !== this.historyRequestSeq) {
                    return;
                }
                if (response.data.success !== true) {
                    return;
                }

                const items = []
                    .concat(response.data.unreadChatHistoryItems || [])
                    .concat(response.data.readChatHistoryItems || []);

                items.forEach((data) => {
                    const payload = this.normalizeChatMessage({
                        channelid: channelid,
                        time: data.sent_at || data.created_at,
                        sent_at: data.sent_at,
                        message: data.message,
                        dbId: data.id,
                        reactions: data.reactions || {},
                        myReactions: data.myReactions || {},
                        sender: {
                            userid: String(data.sender_id),
                            username: this.$props.member_info.username,
                            nickname: data.nickname ?? data.firstname,
                            type: data.message_type,
                        },
                        recipient: {
                            userid: data.recipient_id,
                            type: data.message_type,
                        },
                    });

                    if (this.isDuplicateMessage(payload)) {
                        return;
                    }

                    if (String(data.sender_id) !== String(this.current_chatbox_userid)) {
                        this.newMessageAdded = true;
                    }
                    this.pushPrivateMessage(payload);
                    this.scrollToEnd();
                });
            });
        },
        isDuplicateMessage(data) {
            if (data.clientMsgId) {
                return this.recentMessages.some((row) => String(row.clientMsgId) === String(data.clientMsgId));
            }

            if (data.dbId) {
                const dbId = String(data.dbId);
                return this.recentMessages.some((row) => String(row.dbId) === dbId)
                    || this.messages.some((row) => String(row.dbId) === dbId)
                    || this.unreadMessages.some((row) => String(row.dbId) === dbId);
            }

            return false;
        },
        onPrivateMessageReceived(response) {
            if (!response) {
                return;
            }

            if (!this.isMessageForActiveChannel(response)) {
                return;
            }

            const senderId = response.sender && (response.sender.userid || response.sender.userId);
            if (String(senderId) === String(this.current_chatbox_userid)) {
                return;
            }

            if (this.isDuplicateMessage(response)) {
                return;
            }

            this.newMessageAdded = true;
            this.markMessageRead();
            this.pushPrivateMessage(response);
            this.message = null;
            this.scrollToEnd();
        },
        onReactionReceived(payload) {
            if (!payload) {
                return;
            }

            if (!this.isMessageForActiveChannel(payload)) {
                return;
            }

            const messageId = payload.message_id || payload.messageId || payload.dbId;
            if (!messageId) {
                return;
            }
            const dbId = String(messageId);

            const apply = (row) => {
                if (!row || !row.dbId) {
                    return false;
                }
                if (String(row.dbId) !== dbId) {
                    return false;
                }
                this.ensureReactionState(row);
                if (payload.reactions && typeof payload.reactions === 'object') {
                    this.$set(row, 'reactions', payload.reactions);
                }
                // Only update myReactions for the actor's own client (the other side won't know their myReactions).
                if (payload.user_id && String(payload.user_id) === String(this.current_chatbox_userid) && payload.myReactions) {
                    this.$set(row, 'myReactions', payload.myReactions);
                }
                return true;
            };

            const lists = [this.messages, this.unreadMessages, this.recentMessages];
            for (let li = 0; li < lists.length; li += 1) {
                const list = lists[li] || [];
                for (let i = 0; i < list.length; i += 1) {
                    if (apply(list[i])) {
                        return;
                    }
                }
            }
        },
        getUser() {
            const channelid = this.activeChannelId();
            const userId = this.$props.user_info.id || this.$props.member_info.user_id;

            if (this.$props.user_info.user_type == "MEMBER") {
                return {
                    channelid: channelid,
                    userid: String(userId),
                    username: this.$props.member_info.username,
                    nickname: this.$props.member_info.nickname,
                    user_image: this.user_image,
                    type: this.$props.user_info.user_type,
                    status: 'online',
                    chat_type: 'sender'
                }
            } else if (this.$props.user_info.user_type == "TUTOR") {
                return {
                    channelid: channelid,
                    userid: String(userId),
                    username: this.$props.user_info.username,
                    nickname: this.$props.user_info.firstname,
                    user_image: this.user_image,
                    type: this.$props.user_info.user_type,
                    status: 'online',
                    chat_type: 'sender'
                }
            }
        },
        getRecipient() {
            return this.$props.recipient_info;
        },
        pushPrivateMessage(data) {
            if (this.isDuplicateMessage(data)) {
                return;
            }
            this.recentMessages.push(this.normalizeChatMessage(data));
        },
        parseChatTimestamp(value) {
            if (value == null || value === '') {
                return null;
            }
            if (value instanceof Date) {
                return isNaN(value.getTime()) ? null : value;
            }
            if (typeof value === 'number') {
                const numeric = new Date(value);
                return isNaN(numeric.getTime()) ? null : numeric;
            }

            const str = String(value).trim();
            let parsed = new Date(str);
            if (!isNaN(parsed.getTime())) {
                return parsed;
            }

            const jp = str.match(/(\d{4})\s*年\s*(\d{1,2})\s*月\s*(\d{1,2})\s*日(?:\s*(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
            if (jp) {
                parsed = new Date(
                    Number(jp[1]),
                    Number(jp[2]) - 1,
                    Number(jp[3]),
                    Number(jp[4] || 0),
                    Number(jp[5] || 0),
                    Number(jp[6] || 0)
                );
                return isNaN(parsed.getTime()) ? null : parsed;
            }

            const mysql = str.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
            if (mysql) {
                parsed = new Date(
                    Number(mysql[1]),
                    Number(mysql[2]) - 1,
                    Number(mysql[3]),
                    Number(mysql[4]),
                    Number(mysql[5]),
                    Number(mysql[6] || 0)
                );
                return isNaN(parsed.getTime()) ? null : parsed;
            }

            const tutorDisplay = str.match(/^(\d{1,2})\s+([A-Za-z]+)\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?$/i);
            if (tutorDisplay) {
                const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
                const monthIndex = monthNames.indexOf(String(tutorDisplay[2]).toLowerCase());
                if (monthIndex >= 0) {
                    let hour = Number(tutorDisplay[3]);
                    const minute = Number(tutorDisplay[4]);
                    const ampm = tutorDisplay[6] ? String(tutorDisplay[6]).toUpperCase() : null;
                    if (ampm === 'PM' && hour < 12) {
                        hour += 12;
                    }
                    if (ampm === 'AM' && hour === 12) {
                        hour = 0;
                    }
                    parsed = new Date(new Date().getFullYear(), monthIndex, Number(tutorDisplay[1]), hour, minute, Number(tutorDisplay[5] || 0));
                    return isNaN(parsed.getTime()) ? null : parsed;
                }
            }

            return null;
        },
        chatMessageTimestampSource(data) {
            if (!data) {
                return null;
            }
            return data.sent_at
                || data.sentAt
                || data.created_at_raw
                || data.time
                || data.created_at
                || null;
        },
        displayTimeLabel(chatlog) {
            if (!chatlog) {
                return '';
            }
            if (chatlog.timeLabel) {
                return chatlog.timeLabel;
            }
            return this.formatChatTimeLabel(
                chatlog.sentAt || this.chatMessageTimestampSource(chatlog)
            );
        },
        formatChatDateKey(date) {
            if (!date) {
                return '';
            }
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        },
        formatChatTimeLabel(value) {
            const date = this.parseChatTimestamp(value);
            if (!date) {
                return '';
            }
            return date.toLocaleTimeString(undefined, {
                hour: 'numeric',
                minute: '2-digit',
            });
        },
        formatChatDateLabel(date) {
            if (!date) {
                return '';
            }

            const now = new Date();
            const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const startOfMsg = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const dayDiff = Math.round((startOfToday - startOfMsg) / 86400000);

            const lang = (typeof navigator !== 'undefined' && navigator.language) || 'en';
            const isJa = lang.toLowerCase().indexOf('ja') === 0;

            if (dayDiff === 0) {
                return isJa ? '今日' : 'Today';
            }
            if (dayDiff === 1) {
                return isJa ? '昨日' : 'Yesterday';
            }

            return date.toLocaleDateString(undefined, {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
        formatChatDateDividerLabel(row) {
            const date = this.parseChatTimestamp(row && (row.sentAt || row.time));
            return this.formatChatDateLabel(date);
        },
        lastMessageInLists(...lists) {
            for (let i = lists.length - 1; i >= 0; i -= 1) {
                const list = lists[i];
                if (list && list.length) {
                    return list[list.length - 1];
                }
            }
            return null;
        },
        shouldShowChatDateDivider(list, index, ...priorLists) {
            const row = list[index];
            if (!row) {
                return false;
            }
            const prev = index > 0 ? list[index - 1] : this.lastMessageInLists(...priorLists);
            if (!prev) {
                return true;
            }
            const curKey = row.dateKey || this.formatChatDateKey(this.parseChatTimestamp(row.sentAt || row.time));
            const prevKey = prev.dateKey || this.formatChatDateKey(this.parseChatTimestamp(prev.sentAt || prev.time));
            return curKey !== prevKey;
        },
        normalizeChatMessage(data) {
            const rawTime = this.chatMessageTimestampSource(data);
            const sentAt = this.parseChatTimestamp(rawTime);
            const channelid = data.channelid != null ? String(data.channelid) : this.activeChannelId();
            return Object.assign({}, data, {
                channelid: channelid,
                sentAt: sentAt ? sentAt.toISOString() : (data.sentAt || null),
                dateKey: sentAt ? this.formatChatDateKey(sentAt) : (data.dateKey || ''),
                timeLabel: sentAt ? this.formatChatTimeLabel(sentAt) : (data.timeLabel || this.formatChatTimeLabel(rawTime)),
            });
        },
        chatSenderId(chatlog) {
            if (!chatlog || !chatlog.sender) {
                return '';
            }
            return String(chatlog.sender.userid || chatlog.sender.userId || '');
        },
        isOwnChatMessage(chatlog) {
            return this.chatSenderId(chatlog) === String(this.current_chatbox_userid || '');
        },
        shouldShowSenderLabel(list, index) {
            const row = list[index];
            if (!row || !row.sender || this.isOwnChatMessage(row)) {
                return false;
            }
            if (index === 0) {
                return true;
            }
            const prev = list[index - 1];
            return this.chatSenderId(prev) !== this.chatSenderId(row);
        },
        sendMessage: function (message) {

            this.privateMessage = message;

            //files is empty and message is empty, stop sending message
            if (this.files.length == 0 && message === "" || message === undefined) {
                //console.log("no message")
                return false;
            }
            else if (this.files.length >= 1 && message === "") {
                //console.log("upload file only")     
                //upload the file only
                const uploader = this.$refs.upload;
                if (uploader) {
                    uploader.active = true;
                }
            } else if (this.files.length >= 1 && message !== "") {
                //upload both
                //console.log("both files and message")
                const uploader = this.$refs.upload;
                if (uploader) {
                    uploader.active = true;
                    console.log("m4")
                }
            } else if (this.files.length == 0 && message !== "") {
                this.emitMessage(this.privateMessage);
                this.clearComposeMessage();
                this.$nextTick(() => {
                    this.scrollToEnd();
                });
            }
        },
        emitMessage(message) {
            if (!this.socket) {
                this.connectChatSocket();
            }
            if (!this.socket) {
                console.warn('[lesson-chat] cannot send — socket not connected');
                return;
            }

            const sender = this.getUser();
            const recipient = this.getRecipient();
            const recipientId = recipient && (recipient.userid || recipient.userId);
            if (!sender || !recipientId) {
                console.warn('[lesson-chat] cannot send — missing sender or recipient');
                return;
            }

            const currentTime = new Date();
            const channelid = this.activeChannelId();
            const time = currentTime.toISOString();

            const clientMsgId = `local-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
            const payload = this.normalizeChatMessage({ channelid, time, recipient, sender, message, clientMsgId });

            this.newMessageAdded = true;
            this.pushPrivateMessage(payload);
            this.scrollToEnd();

            this.socket.emit('SEND_SLIDE_PRIVATE_MESSAGE', payload);

            axios.post("/api/saveLessonChat?api_token=" + this.api_token,
                {
                    method: "POST",
                    channelid: channelid,
                    sender_id: sender.userid,
                    recipient_id: recipientId,
                    message: message,
                    is_read: false,
                    valid: true,
                    message_type: sender.type,

                }).then(response => {
                    if (response.data.success === true) {
                        //@todo: HIGHLIGHT or add confirmation
                    } else {
                        //@todo: HIGHLIGHT error
                    }
                }).catch(function (error) {
                    console.log("Error " + error);
                });
        },
        markMessageRead() {
            this.scrollToEnd();

            axios.post("/api/markLessonChatMessagesRead?api_token=" + this.api_token, {
                method: "POST",
                channelid: this.activeChannelId()
            }).then(response => {
                //console.log("marked read")
            });
        },
        getChatHistory() {

            this.isFetching = true;

            const channelid = this.activeChannelId();
            const requestSeq = ++this.historyRequestSeq;
            this.clearChatMessages();

            //user is the sender
            axios.post("/api/getLessonChathistory?api_token=" + this.api_token,
                {
                    method: "POST",
                    channelid: channelid
                }).then(response => {

                    if (requestSeq !== this.historyRequestSeq) {
                        return;
                    }

                    if (response.data.success === true) {

                        this.isFetching = false;


                        //unread
                        let unreadChatHistoryItems = response.data.unreadChatHistoryItems

                        unreadChatHistoryItems.forEach(data => {
                            let message = data.message;
                            let time = data.sent_at || data.created_at;

                            let sender = {
                                userid: String(data.sender_id),
                                username: this.$props.member_info.username,
                                nickname: data.nickname ?? data.firstname,
                                type: data.message_type
                            }

                            let recipient = {
                                userid: data.recipient_id,
                                //nickname:   "recipient",
                                type: data.message_type
                            }

                            this.unreadMessages.unshift(this.normalizeChatMessage({ channelid, time, sent_at: data.sent_at, recipient, sender, message }));
                        });


                        //read
                        let readChatHistoryItems = response.data.readChatHistoryItems

                        readChatHistoryItems.forEach(data => {
                            let message = data.message;
                            let time = data.sent_at || data.created_at;

                            let sender = {
                                userid: String(data.sender_id),
                                username: this.$props.member_info.username,
                                nickname: data.nickname ?? data.firstname,
                                type: data.message_type
                            }

                            let recipient = {
                                userid: data.recipient_id,
                                //nickname:   "recipient",
                                type: data.message_type
                            }

                            this.messages.unshift(this.normalizeChatMessage({ channelid, time, sent_at: data.sent_at, recipient, sender, message }));
                        });

                        this.$nextTick(() => {
                            this.scrollToEnd();
                        });

                    }
                }).catch(() => {
                    if (requestSeq === this.historyRequestSeq) {
                        this.isFetching = false;
                    }
                });

        },
        scrollToTop: function () {
            this.$forceUpdate();

            var container = this.$el.querySelector("#user-chatlog");
            if (container) {
                container.scrollTop = 0;
            }
        },

        onEditorReady(editor) {
            const editable = editor.editable();
            if (editable) {
                editable.setAttribute('data-placeholder', 'Type a message');
            }

            editor.on('key', (evt) => {
                const keyCode = evt.data.keyCode;
                const domEvent = evt.data.domEvent && evt.data.domEvent.$;
                const shiftKey = domEvent && domEvent.shiftKey;

                if (keyCode === 13 && !shiftKey) {
                    evt.cancel();
                    this.sendComposeMessage();
                    return;
                }

                setTimeout(() => this.resizeChatEditor(), 0);
            });

            editor.on('selectionChange', () => {
                this.syncEditorFormatState();
            });

            editor.on('focus', () => {
                this.syncEditorFormatState();
            });

            editor.on('change', () => {
                this.resizeChatEditor();
                this.syncEditorFormatState();
            });

            editor.on('paste', () => {
                this.handlePasteImage();
                setTimeout(() => {
                    this.resizeChatEditor();
                    this.scrollToEnd();
                }, 100);
            });

            this.$nextTick(() => {
                this.resizeChatEditor();
                this.syncEditorFormatState();
            });
        },

        async handlePasteImage(evt) {
            try {
                const items = await navigator.clipboard.read();

                for (const item of items) {
                    for (const type of item.types) {
                        if (type.startsWith("image/")) {
                            const blob = await item.getType(type);
                            // Optional: give it a name
                            const timestamp = Date.now();
                            const namedFile = new File([blob], `pasted_${timestamp}.png`, { type: blob.type });

                            console.log("📸 Real clipboard image detected:", namedFile);
                            // 👇 Add file to uploader (if using vue-upload-component)
                            if (this.$refs.upload) this.$refs.upload.add(namedFile);


                            evt.cancel();
                            return; // stop after first image found
                        }
                    }
                }

                console.warn("⚠️ No image found in clipboard");
                //this.handlePasteHtml(evt)?.();
                setTimeout(() => {
                    this.scrollToEnd();
                }, 500);


            } catch (err) {
                console.error("❌ Clipboard image read failed:", err);
            }
        },
        async handlePasteHtml(evt) {
            try {
                const items = await navigator.clipboard.read(); // full clipboard items
                for (const item of items) {
                    for (const type of item.types) {
                        if (type === 'text/html') {
                            const blob = await item.getType(type);
                            const html = await blob.text();

                            
                            // insert into CKEditor (preserves formatting)
                            const editor = this.$refs.ckeditorMessage.instance;
                            if (editor) {
                                //editor.setData(this.privateMessage + " " + html); // replaces content
                                 editor.insertHtml(html); // appends at cursor
                            }
                            console.log("🧩 HTML content pasted with formatting");

                            evt.cancel();

                            return;
                        }
                    }
                }

                console.warn("⚠️ No HTML content found in clipboard");

            } catch (err) {
                console.error("❌ Clipboard read failed:", err);
            }
        },

     

        // helper: convert Blob to base64 string
        blobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },



        async handlePasteText() {
            try {
                // Read text from the system clipboard (requires HTTPS or localhost)
                const text = await navigator.clipboard.readText();

                // Assign to your v-model
                this.privateMessage = this.privateMessage  + "  " + text;

                console.log("📋 Copied text pasted into privateMessage:", text);
            } catch (err) {
                console.warn("⚠️ Unable to read clipboard:", err);
            }
        },
        handlePaste(event) {

            const items = event.clipboardData?.items || window.clipboardData;

            console.log("✅ handlePaste Event Fired");

            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.type.indexOf('image') !== -1) {
                    const file = item.getAsFile();

                    const timestamp = Date.now();
                    const namedFile = new File([file], `pasted_${timestamp}.png`, {
                        type: file.type,
                    });

                    // 👇 Send it to your uploader
                    this.$refs.upload.add(namedFile);
                    console.log("📸 Image pasted and added to uploader:", namedFile);
                    break;
                } else {
                    console.log("No Image ");

                    this.handlePasteHtml();
                }
            }
        },

        updatetValue(value) {
            //this.files = value;
        },
        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function (newFile, oldFile) {

            console.log(newFile, oldFile);

            this.prepareButtons();

            if (newFile && oldFile && !newFile.active && oldFile.active) {
                if (newFile.xhr) {
                    if (newFile.xhr.status === 200) {


                        //file information
                        let file = [{
                            'id': newFile.response.id,
                            'file_name': newFile.response.file,
                            'size': newFile.response.size,
                        }];

                        this.emitMessage(newFile.response.image);

                        if (this.privateMessage !== '') {
                            this.emitMessage(this.privateMessage);
                            this.clearComposeMessage();
                        }


                    }

                }
            }

            if (this.$refs.upload.uploaded) {
                // console.log("all queue uploaded");
                this.files = [];
                this.scrollToEnd();
            }


            setTimeout(() => {
                this.scrollToEnd();
                console.log("attached files to upload...")
            }, 500);
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|doc|docx)$/i.test(newFile.name)) {
                    return prevent();
                }
            }


            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
                // Thumbnails
                newFile.thumb = ''
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob
                }
            }
        },
        prepareButtons: function () {
            //console.log(this.files.length);

            let message = document.getElementById("message").value;
            //let fileSelectBtn = document.getElementById("file-select-button");
            let sendBtn = document.getElementById("send-button");

            if (message == "" && this.files.length == 0) {

                /*
                if (fileSelectBtn) {
                    fileSelectBtn.style.display = "block";
                }
                */

                if (sendBtn) {
                    sendBtn.style.display = "none";
                }
            } else {
                
                /*
                if (fileSelectBtn) {
                    fileSelectBtn.style.display = "none";
                }
                    */

                if (sendBtn) {
                    sendBtn.style.display = "block";
                }
            }
        },

        initializeChatBox: function (user) {
            if (user) {
                this.current_chatbox_userid = String(user.userid || user.userId || '');
            }
            this.$forceUpdate();
            this.$nextTick(function () {
                this.scrollToEnd();
                this.prepareButtons();
            });
        },
        delayandMarkUnread() {
            console.log("delay fired")
            this.interval = setInterval(this.prepeareMarkRead, 1500);
        },
        prepeareMarkRead() {
            this.markMessagesRead(this.userid)
        },
        markMessagesRead(userid) {

            console.log("marking read")
            clearInterval(this.interval);

            axios.post("/api/markChatMessagesRead?api_token=" + this.api_token,
                {
                    method: "POST",
                    userID: userid,
                    message_type: 'CHAT_SUPPORT'
                }).then(response => {

                    if (response.data.success === true) {
                        this.unread_message_count = 0;
                        clearInterval(this.interval);

                    } else {
                        clearInterval(this.interval);
                    }
                });
        },
        updateUserList: function (users) {
            this.users = users;
            this.$forceUpdate();
        },
        scrollToEnd: function () {
            this.$forceUpdate();

            this.$nextTick(function () {
                var container = this.$el.querySelector("#user-chatlog");

                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });

        },

    },
    computed: {
        reactionPickerTabs() {
            return [
                { id: 'recent', label: 'Recent', icon: '🕘' },
                { id: 'smileys', label: 'Smileys', icon: '😄' },
                { id: 'people', label: 'People', icon: '👍' },
                { id: 'activities', label: 'Activities', icon: '🎉' },
                { id: 'objects', label: 'Objects', icon: '📝' },
                { id: 'symbols', label: 'Symbols', icon: '✅' },
            ];
        },
        reactionPickerTabLabel() {
            const tab = (this.reactionPickerTabs || []).find((t) => t.id === this.reactionPickerTab);
            return tab ? tab.label : '';
        },
        reactionPickerCategoryMap() {
            // Curated for current emoji set; extend as you add more emoji.
            return {
                smileys: ['😀', '😁', '😅', '😊', '😉', '😍', '😘', '🤔', '😴', '😎', '🤩', '🙈', '😮', '😢', '😡', '😂'],
                people: ['👍', '👎', '👏', '🙏', '🙌', '💪', '🤝'],
                activities: ['🎉', '🔥', '🎯', '✨', '🌟', '💯', '❤️'],
                objects: ['📌', '📝'],
                symbols: ['✅', '❌'],
            };
        },
        reactionPickerVisibleEmojis() {
            const q = String(this.reactionPickerSearch || '').trim().toLowerCase();

            let base = [];
            if (this.reactionPickerTab === 'recent') {
                base = (this.reactionPickerRecent || []).slice();
            } else {
                base = (this.reactionPickerCategoryMap[this.reactionPickerTab] || []).slice();
            }

            // Fallback: if category list is empty, show full list.
            if (!base.length) {
                base = (this.reactionEmojiList || []).slice();
            }

            // Dedupe while preserving order.
            const seen = new Set();
            base = base.filter((e) => {
                if (seen.has(e)) return false;
                seen.add(e);
                return true;
            });

            if (!q) return base;

            // Simple search: match by emoji itself or common keyword aliases.
            const aliases = {
                thumb: '👍',
                up: '👍',
                down: '👎',
                love: '❤️',
                heart: '❤️',
                laugh: '😂',
                cry: '😢',
                angry: '😡',
                clap: '👏',
                pray: '🙏',
                fire: '🔥',
                party: '🎉',
                check: '✅',
                x: '❌',
                pin: '📌',
                note: '📝',
                star: '🌟',
                sparkle: '✨',
                target: '🎯',
                wow: '😮',
                think: '🤔',
                sleep: '😴',
                cool: '😎',
            };

            const aliasEmoji = Object.keys(aliases)
                .filter((k) => k.includes(q))
                .map((k) => aliases[k]);

            const set = new Set(aliasEmoji);
            return base.filter((e) => e.includes(q) || set.has(e));
        },
        emojiPickerTabs() {
            return [
                { id: 'recent', label: 'Recent', icon: '🕘' },
                { id: 'smileys', label: 'Smileys', icon: '😄' },
                { id: 'people', label: 'People', icon: '👍' },
                { id: 'activities', label: 'Activities', icon: '🎉' },
                { id: 'objects', label: 'Objects', icon: '📝' },
                { id: 'symbols', label: 'Symbols', icon: '✅' },
            ];
        },
        emojiPickerTabLabel() {
            const tab = (this.emojiPickerTabs || []).find((t) => t.id === this.emojiPickerTab);
            return tab ? tab.label : '';
        },
        emojiPickerCategoryMap() {
            return this.reactionPickerCategoryMap;
        },
        emojiPickerVisibleEmojis() {
            const q = String(this.emojiPickerSearch || '').trim().toLowerCase();

            let base = [];
            if (this.emojiPickerTab === 'recent') {
                base = (this.emojiPickerRecent || []).slice();
            } else {
                base = (this.emojiPickerCategoryMap[this.emojiPickerTab] || []).slice();
            }

            if (!base.length) {
                base = (this.reactionEmojiList || []).slice();
            }

            const seen = new Set();
            base = base.filter((e) => {
                if (seen.has(e)) return false;
                seen.add(e);
                return true;
            });

            if (!q) return base;

            const aliases = {
                thumb: '👍',
                up: '👍',
                down: '👎',
                love: '❤️',
                heart: '❤️',
                laugh: '😂',
                cry: '😢',
                angry: '😡',
                clap: '👏',
                pray: '🙏',
                fire: '🔥',
                party: '🎉',
                check: '✅',
                x: '❌',
                pin: '📌',
                note: '📝',
                star: '🌟',
                sparkle: '✨',
                target: '🎯',
                wow: '😮',
                think: '🤔',
                sleep: '😴',
                cool: '😎',
            };

            const aliasEmoji = Object.keys(aliases)
                .filter((k) => k.includes(q))
                .map((k) => aliases[k]);

            const set = new Set(aliasEmoji);
            return base.filter((e) => e.includes(q) || set.has(e));
        },
    },

};
</script>


<style>
.img_preview {
    width: 100%;
}

.custom-pdf {
    font-size: 100px;
}
</style>


<style scoped>
.img_preview {
    width: 100px;
}

#fileUpload {
    display: none;
}



.bg-blue {
    background-color: #009fd9
}

.border-blue {
    border-color: #009fd9
}


.custom-btn-input {
    margin-right: 2px;
    padding: 9px 9px;
    line-height: 0px;
    font-size: 10px;
}

.position-bottom-right {
    position: fixed;
    bottom: 0px;
    right: 75px;
    z-index: 9999;
}

#floating-history-btn {
    font-size: 11px;
    padding: 2px 5px 2px;
    position: absolute;
    top: 42px;
    left: 215px;
    z-index: 1;
}


.btn-xs {
    font-size: 11px;
    padding: 2px 5px 2px;
}

.chatlog-wrapper {
    margin-top: 5px;
    width: 100%;
}

.chat-row {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 6px;
    clear: both;
    position: relative;
}

.chat-row--mine {
    align-items: flex-end;
}

.chat-row--theirs {
    align-items: flex-start;
}

.chat-sender-label {
    font-size: 11px;
    font-weight: 600;
    color: #5f6368;
    margin-bottom: 2px;
    padding: 0 4px;
    max-width: 85%;
}

.chat-row--mine .chat-sender-label {
    text-align: right;
}

.chat-row--theirs .chat-sender-label {
    text-align: left;
}

.chat-bubble {
    max-width: 85%;
    padding: 6px 10px;
    border-radius: 12px;
    font-size: 14px;
    line-height: 1.45;
    text-align: left;
    word-wrap: break-word;
}

.chat-line {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    max-width: 100%;
}

.chat-row--mine .chat-line {
    flex-direction: row-reverse;
}

.chat-time-outside {
    flex: 0 0 auto;
    font-size: 12px;
    line-height: 1;
    color: #605e5c;
    white-space: nowrap;
    user-select: none;
    opacity: 0.85;
    margin-bottom: 2px;
}

.chat-row--mine .chat-time-outside {
    text-align: right;
}

.chat-row--theirs .chat-time-outside {
    text-align: left;
}

.chat-bubble:has(.emoji-only) {
    padding: 2px 2px;
}

.chat-bubble:has(.emoji-only) .chat-reactions {
    margin-top: 2px;
}

.chat-bubble:has(.emoji-only) .chat-meta {
    margin-top: 2px;
}

.chat-row--mine .chat-bubble {
    background-color: #DBF4FC;
    border-bottom-right-radius: 4px;
}

.chat-row--theirs .chat-bubble {
    background-color: #F2F6F9;
    border-bottom-left-radius: 4px;
}

.chat-meta {
    margin-top: 0;
    white-space: nowrap;
    flex: 0 0 auto;
}

.chat-row--theirs .chat-meta {
    text-align: left;
}

.chat-button {
    border-radius: 50%;
    height: 65px;
    width: 65px;
    padding: 0px;
}


.user-chatlog {
    border: 1px solid #ececec;
    padding: 5px 5px 10px;
    min-height: 250px;
    max-height: 275px;
    margin-bottom: 3px;
    overflow-x: hidden;
    overflow-y: scroll;
}

.member-info {
    text-align: right;
}

.member-image {
    float: right;
    border-radius: 50%;
    margin-left: 30px;
    border: 3px solid #ededed;
}

/* SENDER BUBBLE */
.sender-container {
    width: 100%;
    clear: both;
}

.sender-container .message-container {
    position: relative;
    float: right;
}

.sender-container .message {
    position: relative;
    background-color: #DBF4FC;
    border-radius: .4em;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 92%;
    padding: 6px 10px;
    margin-bottom: 7px;
    text-align: left;
    font-size: 14px;
    line-height: 1.45;
}


/* RECIPIENT BUBBLE */
.recipient-container {
    width: 100%;
    clear: both;
}

.recipient-container .message-container {
    position: relative;
    float: left;
}

.recipient-container .message {
    position: relative;
    background-color: #F2F6F9;
    border-radius: .4em;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 92%;
    padding: 6px 10px;
    margin-bottom: 7px;
    text-align: left;
    font-size: 14px;
    line-height: 1.45;
}

.chat-message-body {
    display: block;
    font-size: 14px;
    line-height: 1.45;
    word-wrap: break-word;
    overflow-wrap: anywhere;
}

.chat-message-body >>> .emoji-only {
    display: inline-block;
    line-height: 1.15;
    letter-spacing: 0;
    animation: lessonEmojiPop 220ms ease-out;
}

.chat-message-body >>> .emoji-only--xl {
    font-size: 72px !important;
    line-height: 1.08;
}

.chat-message-body >>> .emoji-only--lg {
    font-size: 56px !important;
    line-height: 1.1;
}

.chat-message-body >>> .emoji-only--md {
    font-size: 44px !important;
}

@media (prefers-reduced-motion: reduce) {
    .chat-message-body >>> .emoji-only {
        animation: none !important;
    }
}

@keyframes lessonEmojiPop {
    0% {
        transform: scale(0.85);
        opacity: 0.6;
    }
    70% {
        transform: scale(1.08);
        opacity: 1;
    }
    100% {
        transform: scale(1);
    }
}

.chat-reactions {
    position: relative;
    margin-top: 4px;
}

.chat-reaction-summary {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4px;
}

.chat-reaction-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 6px;
    border-radius: 999px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.92);
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
}

.chat-row--mine .chat-reaction-pill {
    background: rgba(219, 244, 252, 0.9);
}

.chat-reaction-pill.is-mine {
    border-color: rgba(53, 187, 235, 0.55);
    box-shadow: inset 0 0 0 1px rgba(53, 187, 235, 0.35);
}

.chat-reaction-emoji {
    font-size: 14px;
}

.chat-reaction-count {
    font-weight: 700;
    color: #323130;
}

.chat-reaction-actions {
    position: absolute;
    bottom: calc(100% + 4px);
    right: 0;
    display: inline-flex;
    gap: 4px;
    padding: 4px 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    z-index: 20;
}

.chat-row--theirs .chat-reaction-actions {
    left: 0;
    right: auto;
}

.chat-reaction-btn--more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.chat-reaction-picker-portal {
    position: fixed;
    width: 360px;
    max-width: calc(100vw - 16px);
    padding: 10px;
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.chat-reaction-picker-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.chat-reaction-picker-search {
    width: 100%;
    height: 34px;
    padding: 6px 10px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    outline: none;
    font-size: 13px;
}

.chat-reaction-picker-search:focus {
    border-color: rgba(53, 187, 235, 0.8);
    box-shadow: 0 0 0 2px rgba(53, 187, 235, 0.18);
}

.chat-reaction-picker-tabs {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 0;
    overflow-x: auto;
}

.chat-reaction-picker-tab {
    width: 32px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    color: #323130;
    flex: 0 0 auto;
}

.chat-reaction-picker-tab:hover {
    background: #e8f4fc;
}

.chat-reaction-picker-tab.is-active {
    background: rgba(53, 187, 235, 0.18);
    box-shadow: inset 0 0 0 1px rgba(53, 187, 235, 0.35);
}

.chat-reaction-picker-body {
    max-height: 320px;
    overflow: auto;
    padding-right: 2px;
}

.chat-reaction-picker-section-title {
    font-size: 12px;
    font-weight: 700;
    color: #605e5c;
    margin: 2px 2px 6px;
}

.chat-reaction-picker-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 4px;
}

.chat-reaction-picker-item {
    width: 100%;
    height: 36px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    font-size: 20px;
    line-height: 1;
}

.chat-reaction-picker-item:hover {
    background: #e8f4fc;
}

.chat-reaction-picker-empty {
    grid-column: 1 / -1;
    padding: 14px 8px;
    font-size: 12px;
    color: #605e5c;
    text-align: center;
}

.chat-row--mine .chat-reaction-actions {
    right: 0;
}

.chat-reaction-btn {
    width: 28px;
    height: 26px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
}

.chat-reaction-btn:hover {
    background: #e8f4fc;
}

.chat-message-body >>> p,
.chat-message-body >>> div,
.chat-message-body >>> span,
.chat-message-body >>> li {
    font-size: 14px !important;
    line-height: 1.45 !important;
}

.chat-message-body >>> a.chat-link {
    font-size: 14px !important;
    line-height: 1.45 !important;
    color: #0078d4;
    text-decoration: underline;
    cursor: pointer;
}

.chat-message-body >>> a.chat-link:hover {
    color: #106ebe;
}

.chat-message-body >>> p {
    margin: 0 0 4px;
}

.chat-message-body >>> p:last-child {
    margin-bottom: 0;
}

.chat-message-body >>> ul,
.chat-message-body >>> ol {
    margin: 0 0 4px;
    padding-left: 1.25rem;
}

.chat-message-body >>> img {
    max-width: 100%;
    height: auto;
}

.lesson-chat-reply {
    width: 100%;
    padding: 0;
    margin: 0;
}

.lesson-chat-compose {
    position: relative;
    z-index: 3;
    border: 1px solid #c8c6c4;
    border-radius: 8px;
    background: #fff;
    overflow: visible;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    pointer-events: auto;
}

.lesson-chat-compose:focus-within {
    border-color: #35bbeb;
    box-shadow: 0 0 0 2px rgba(53, 187, 235, 0.2);
}

.lesson-chat-format-bar {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 6px;
    background: #faf9f8;
    border-bottom: 1px solid #edebe9;
    position: relative;
    z-index: 2;
    pointer-events: auto;
}

.lesson-chat-format-tools {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0;
    min-width: 0;
}

.lesson-chat-tool-btn {
    color: #605e5c !important;
    padding: 4px 7px !important;
    line-height: 1;
    min-width: 30px;
}

.lesson-chat-tool-btn:hover {
    color: #35bbeb !important;
    background: #e8f4fc !important;
}

.lesson-chat-tool-btn.is-active {
    color: #fff !important;
    background: #35bbeb !important;
    box-shadow: inset 0 0 0 1px #2aa8d6;
}

.lesson-chat-tool-btn.is-active:hover {
    color: #fff !important;
    background: #2aa8d6 !important;
}

.lesson-chat-format-more {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.lesson-chat-paragraph-style-btn {
    display: inline-flex !important;
    align-items: center;
    gap: 4px;
    min-width: 0 !important;
    max-width: 100%;
    height: 28px;
    padding: 2px 8px !important;
    white-space: nowrap;
}

.lesson-chat-paragraph-style-label {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
}

.lesson-chat-paragraph-style-caret {
    font-size: 10px;
    opacity: 0.75;
}

.lesson-chat-format-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 20;
    min-width: 132px;
    padding: 4px 0;
    background: #fff;
    border: 1px solid #dadce0;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.lesson-chat-format-menu-item {
    display: block;
    width: 100%;
    padding: 7px 12px;
    border: none;
    background: transparent;
    color: #323130;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
}

.lesson-chat-format-menu-item:hover {
    background: #e8f4fc;
    color: #35bbeb;
}

.lesson-chat-format-sep {
    display: inline-block;
    width: 1px;
    height: 18px;
    margin: 0 4px;
    background: #dadce0;
    align-self: center;
}

.lesson-chat-editor-wrap {
    background: #fff;
    position: relative;
    z-index: 1;
    pointer-events: auto;
    overflow: hidden;
    border-radius: 0;
}

.lesson-chat-editor-wrap .cke,
.lesson-chat-editor-wrap .cke_inner,
.lesson-chat-editor-wrap .cke_contents,
.lesson-chat-editor-wrap iframe {
    pointer-events: auto !important;
}

.lesson-chat-editor-wrap .cke_chrome {
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
}

.lesson-chat-editor-wrap .cke_top,
.lesson-chat-editor-wrap .cke_bottom {
    display: none !important;
}

.lesson-chat-editor-wrap .cke_inner {
    background: #fff !important;
}

.lesson-chat-editor-wrap .cke_contents {
    min-height: 44px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    background: #fff !important;
}

.lesson-chat-editor-wrap .cke_editable {
    min-height: 36px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
    line-height: 1.45 !important;
}

.lesson-chat-editor-wrap .cke_editable.cke_editable_inline[data-placeholder]:empty:before {
    content: attr(data-placeholder);
    color: #8a8886;
    font-style: normal;
}

.lesson-chat-actions-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 6px 6px;
    background: #faf9f8;
    border-top: 1px solid #edebe9;
    position: relative;
    z-index: 2;
    pointer-events: auto;
}

.lesson-chat-actions-left,
.lesson-chat-actions-right {
    display: flex;
    align-items: center;
    gap: 2px;
}

.lesson-chat-emoji {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.lesson-chat-emoji-menu {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 0;
    z-index: 30;
    width: 248px;
    padding: 8px;
    background: #fff;
    border: 1px solid #dadce0;
    border-radius: 10px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    gap: 4px;
}

.lesson-chat-emoji-menu--teams {
    width: 360px;
    max-width: calc(100vw - 16px);
    padding: 10px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.lesson-chat-emoji-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.lesson-chat-emoji-search {
    width: 100%;
    height: 34px;
    padding: 6px 10px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    outline: none;
    font-size: 13px;
}

.lesson-chat-emoji-search:focus {
    border-color: rgba(53, 187, 235, 0.8);
    box-shadow: 0 0 0 2px rgba(53, 187, 235, 0.18);
}

.lesson-chat-emoji-tabs {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 0;
    overflow-x: auto;
}

.lesson-chat-emoji-tab {
    width: 32px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    color: #323130;
    flex: 0 0 auto;
}

.lesson-chat-emoji-tab:hover {
    background: #e8f4fc;
}

.lesson-chat-emoji-tab.is-active {
    background: rgba(53, 187, 235, 0.18);
    box-shadow: inset 0 0 0 1px rgba(53, 187, 235, 0.35);
}

.lesson-chat-emoji-body {
    max-height: 320px;
    overflow: auto;
    padding-right: 2px;
}

.lesson-chat-emoji-section-title {
    font-size: 12px;
    font-weight: 700;
    color: #605e5c;
    margin: 2px 2px 6px;
}

.lesson-chat-emoji-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 4px;
}

.lesson-chat-emoji-empty {
    grid-column: 1 / -1;
    padding: 14px 8px;
    font-size: 12px;
    color: #605e5c;
    text-align: center;
}

.lesson-chat-emoji-item {
    border: none;
    background: transparent;
    width: 100%;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
}

.lesson-chat-emoji-item:hover {
    background: #e8f4fc;
}

.lesson-chat-send-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background: #35bbeb;
    color: #fff;
    cursor: pointer;
}

.lesson-chat-send-btn:hover {
    background: #2aa8d6;
}

.lesson-chat-attachments-preview {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
}

.lesson-chat-attachment-chip {
    position: relative;
    width: 72px;
    height: 72px;
    border: 1px solid #edebe9;
    border-radius: 6px;
    overflow: hidden;
    background: #f3f2f1;
}

.lesson-chat-attachment-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.lesson-chat-attachment-file {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 28px;
    color: #605e5c;
}

.lesson-chat-attachment-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 2;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    line-height: 1;
    font-size: 14px;
    cursor: pointer;
}

.lesson-chat-attachment-progress {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    margin: 0;
}

#lesson-chat-service .chat-message-body a.chat-link {
    color: #0078d4;
    text-decoration: underline;
    cursor: pointer;
}

#lesson-chat-service .chat-message-body a.chat-link:hover {
    color: #106ebe;
}

#lesson-chat-service .chat-message-body strong,
#lesson-chat-service .chat-message-body b {
    font-weight: 700;
}

#lesson-chat-service .chat-message-body em,
#lesson-chat-service .chat-message-body i {
    font-style: italic;
}

#lesson-chat-service .chat-message-body u {
    text-decoration: underline;
}

#lesson-chat-service .chat-message-body ul,
#lesson-chat-service .chat-message-body ol {
    margin: 0 0 6px;
    padding-left: 1.25rem;
}

#lesson-chat-service .chat-message-body h3 {
    font-size: 1.05rem;
    font-weight: 600;
    margin: 0 0 6px;
}

#lesson-chat-service .chat-message-body pre {
    margin: 0 0 6px;
    padding: 6px 8px;
    background: #f1f3f4;
    border-radius: 4px;
    font-size: 13px;
    white-space: pre-wrap;
}

.chat-date-divider {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 6px;
    width: 100%;
}

.chat-date-divider span {
    font-size: 11px;
    font-weight: 600;
    color: #5f6368;
    background: #e8eaed;
    padding: 3px 12px;
    border-radius: 12px;
    line-height: 1.3;
}

.chat-time {
    display: inline-block;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    color: #5f6368;
    opacity: 1;
    margin-top: 2px;
}

.strike {
    display: block;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
}

.strike>span {
    position: relative;
    display: inline-block;
    font-size: 10px;
}

.strike>span:before,
.strike>span:after {
    content: "";
    position: absolute;
    top: 50%;
    width: 9999px;
    height: 1px;
    background: #ccc;
}

.strike>span:before {
    right: 100%;
    margin-right: 5px;
}

.strike>span:after {
    left: 100%;
    margin-left: 5px;
}
</style>